import { render, staticRenderFns } from "./CongratulationsPage.vue?vue&type=template&id=3cc47450&scoped=true"
import script from "./CongratulationsPage.vue?vue&type=script&lang=js"
export * from "./CongratulationsPage.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsPage.vue?vue&type=style&index=0&id=3cc47450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc47450",
  null
  
)

export default component.exports